import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-pdf-file-icon',
  templateUrl: './doc-format-pdf-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatPdfFileIconComponent {}
